import { cn } from "@/lib/utils";

export function RightChevronIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[9px] w-1.5 text-white", className)}
      viewBox="0 0 6 9"
      {...props}
    >
      <path
        d="M5.405 4.665a.498.498 0 01-.039.195.52.52 0 01-.122.166l-3.628 3.55a.45.45 0 01-.337.142.48.48 0 01-.341-.825l3.3-3.228-3.3-3.228a.468.468 0 01-.147-.341.48.48 0 01.063-.25.48.48 0 01.425-.234.45.45 0 01.337.142l3.628 3.55a.503.503 0 01.122.17c.026.06.04.123.04.191z"
        fill="currentColor"
      />
    </svg>
  );
}
